// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon {
    width: 24px;
    height: 24px;
    display: inline-block;
}

.icon-vertical {
    display: block;
    margin-bottom: 10px;
}

.icon-horizontal {
    margin-right: 10px;
}

.nav-separator {
    display: flex;
    align-items: center;
    padding: 0 15px;
    font-weight: bold;
    color: #2f292959; /* Dostosuj kolor do swoich potrzeb */
}

.row-hover:hover {
    background-color: var(--bs-secondary-bg-subtle); /* jasne szare tło */
    transition: background-color 0.15s ease-in-out;
    cursor: pointer;
}

.is-warning {
    border-color: #ffc107 !important; /* yellow */
}

/* EntitySelector: menu rozwijane może być szersze niż wąskie pole wpisu,
   żeby 3-liniowe pozycje (nazwa / skrót / adres | NIP) mieściły się bez łamania. */
.entity-selector-wrapper .rbt-menu {
    min-width: 24rem;
    max-width: 42rem;
    width: max-content;
}
`, "",{"version":3,"sources":["webpack://./src/Css/styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB,EAAE,qCAAqC;AAC3D;;AAEA;IACI,+CAA+C,EAAE,oBAAoB;IACrE,8CAA8C;IAC9C,eAAe;AACnB;;AAEA;IACI,gCAAgC,EAAE,WAAW;AACjD;;AAEA;mFACmF;AACnF;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".icon {\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n}\n\n.icon-vertical {\n    display: block;\n    margin-bottom: 10px;\n}\n\n.icon-horizontal {\n    margin-right: 10px;\n}\n\n.nav-separator {\n    display: flex;\n    align-items: center;\n    padding: 0 15px;\n    font-weight: bold;\n    color: #2f292959; /* Dostosuj kolor do swoich potrzeb */\n}\n\n.row-hover:hover {\n    background-color: var(--bs-secondary-bg-subtle); /* jasne szare tło */\n    transition: background-color 0.15s ease-in-out;\n    cursor: pointer;\n}\n\n.is-warning {\n    border-color: #ffc107 !important; /* yellow */\n}\n\n/* EntitySelector: menu rozwijane może być szersze niż wąskie pole wpisu,\n   żeby 3-liniowe pozycje (nazwa / skrót / adres | NIP) mieściły się bez łamania. */\n.entity-selector-wrapper .rbt-menu {\n    min-width: 24rem;\n    max-width: 42rem;\n    width: max-content;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
